import { createAsyncAction } from 'typesafe-actions'

export const getImportLogs = createAsyncAction(
  'Get_Import_Logs__Request',
  'Get_Import_Logs__Success',
  'Get_Import_Logs__Failure',
)<void, any, Error>()
